/* dcl-wahoo-offer.js  (rev 2)
 * 2026-10-03: copy and button now point to the on-page price (dcl-your-price.js);
 *   the card no longer shows to a shopper who already has the code applied.
 * Dialed Cycling Lab. Delivers the Wahoo offer code DC-Wahoo26.
 *
 * Built 2026-09-24 from dcl-sram-offer.js rev 1. Same two rules:
 *
 *   1. NO GIFT CARD. Jake chose discount only for Wahoo, so this card has one
 *      perk, the discount. If a gift card is added later it needs the Silca
 *      pattern in full: a note file, a cart file, a terms page, and a Flow.
 *
 *   2. THE DISCOUNT AMOUNT IS NEVER PRINTED. This follows the Garmin, Lake,
 *      and SRAM rule (Jake's call, 2026-09-24). The number (10%) lives only in
 *      the Shopify discount and lands in the shopper's cart. Neither the
 *      percentage nor the code string appears as page text; the code is only
 *      ever inside the /discount/ URL the button navigates to. Do not add the
 *      number to the copy without asking Jake.
 *
 * SCOPE. Vendor Wahoo, which includes the Speedplay pedals and cleats.
 * theme.liquid loads this script only on vendor Wahoo product pages and the
 * /collections/wahoo page. The Powrlink Zero and ELEMNT Roam 3 were on sale at
 * build and are tagged no-discount.
 *
 * THE HUMANITY GATE stays. A real pointermove, touchstart, keydown or wheel
 * must happen before any trigger counts, so a crawler or MAP monitor that
 * does not execute JavaScript never sees the card at all.
 *
 * STORAGE. seenKey is sessionStorage: the card shows once per visit. savedKey
 * is localStorage: a saved deal survives the shopper closing the tab and
 * coming back later.
 *
 * MASTER SWITCH. theme.liquid only emits this script when the shop metafield
 * dcl.wahoo_offer_enabled is not false. Turning the offer off for a sale
 * also means deactivating DC-Wahoo26 in Discounts.
 */
(function () {
  'use strict';

  if (window.__dclWahooOffer) return;
  window.__dclWahooOffer = true;
  if (!window.DCL_WAHOO_OFFER_ELIGIBLE) return;
  if (navigator.webdriver) return;

  var CFG = {
    code: 'DC-Wahoo26',
    armDelayMs: 1500,
    dwellMs: 3000,
    scrollPct: 0.25,
    seenKey: 'dcl_wahoo_offer_seen',
    savedKey: 'dcl_wahoo_offer_saved'
  };

  var armed = false;
  var human = false;
  var shown = false;
  var dwellDone = false;

  function readSession(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }

  function writeSession(key, value) {
    try { sessionStorage.setItem(key, value); } catch (e) { /* private mode */ }
  }

  function readLocal(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }

  function writeLocal(key, value) {
    try { localStorage.setItem(key, value); } catch (e) { /* private mode */ }
  }

  function clearLocal(key) {
    try { localStorage.removeItem(key); } catch (e) { /* private mode */ }
  }

  function seen() { return readSession(CFG.seenKey) === '1'; }
  function codeApplied() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    if (!m) return false;
    try { return decodeURIComponent(m[1]).toUpperCase() === CFG.code.toUpperCase(); } catch (e) { return false; }
  }
  function saved() { return readLocal(CFG.savedKey) === '1'; }

  function svgMark(paths) {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '21');
    svg.setAttribute('height', '21');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    paths.forEach(function (d) {
      var p = document.createElementNS(ns, 'path');
      p.setAttribute('d', d);
      svg.appendChild(p);
    });
    return svg;
  }

  function tagIcon() {
    return svgMark([
      'M20.59 13.41l-7.17 7.17a2 2 0 0 1 -2.83 0l-7.17 -7.17a2 2 0 0 1 -.59 -1.41v-5a2 2 0 0 1 2 -2h5a2 2 0 0 1 1.41 .59l9.35 9.35',
      'M7 7l.01 0'
    ]);
  }

  function perk(icon, buildCopy) {
    var row = document.createElement('div');
    row.className = 'dcl-wo-perk';
    var mark = document.createElement('span');
    mark.className = 'dcl-wo-mark';
    mark.appendChild(icon);
    row.appendChild(mark);
    var copy = document.createElement('span');
    copy.className = 'dcl-wo-copy';
    buildCopy(copy);
    row.appendChild(copy);
    return row;
  }

  function bold(text) {
    var b = document.createElement('span');
    b.className = 'dcl-wo-strong';
    b.textContent = text;
    return b;
  }

  /* The amount is deliberately absent. See the file header. */
  function discountCopy(el) {
    el.appendChild(document.createTextNode('Hit the button below to unlock your special price, right on the product page.'));
  }

  function apply() {
    /*
     * Shopify's /discount/CODE route applies the code to the cart session and
     * then redirects. Sending them back where they were keeps the shopping flow
     * intact. Clear the saved flag first, so the recall tab does not follow
     * them around after they have taken it.
     */
    clearLocal(CFG.savedKey);
    var back = window.location.pathname + window.location.search;
    window.location.href = '/discount/' + encodeURIComponent(CFG.code) +
      '?redirect=' + encodeURIComponent(back);
  }

  function fade(node) {
    node.classList.remove('is-open');
    setTimeout(function () {
      if (node.parentNode) node.parentNode.removeChild(node);
    }, 250);
  }

  function showTab() {
    if (document.querySelector('.dcl-wo-tab')) return;

    var tab = document.createElement('div');
    tab.className = 'dcl-wo-tab';

    var go = document.createElement('button');
    go.className = 'dcl-wo-tab__go';
    go.type = 'button';
    go.appendChild(document.createTextNode('Your deal is saved'));
    var sub = document.createElement('span');
    sub.textContent = 'Tap to apply it';
    go.appendChild(sub);

    var x = document.createElement('button');
    x.className = 'dcl-wo-tab__x';
    x.type = 'button';
    x.setAttribute('aria-label', 'Dismiss saved deal');
    x.textContent = '×';

    tab.appendChild(go);
    tab.appendChild(x);
    document.body.appendChild(tab);
    requestAnimationFrame(function () { tab.classList.add('is-open'); });

    go.addEventListener('click', apply);
    x.addEventListener('click', function () {
      clearLocal(CFG.savedKey);
      fade(tab);
    });
  }

  function save(wrap) {
    writeLocal(CFG.savedKey, '1');
    fade(wrap);
    setTimeout(showTab, 260);
  }

  function build() {
    var wrap = document.createElement('div');
    wrap.className = 'dcl-wo-wrap';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-label', 'Wahoo offer');

    var card = document.createElement('div');
    card.className = 'dcl-wo-card';

    var x = document.createElement('button');
    x.className = 'dcl-wo-close';
    x.type = 'button';
    x.setAttribute('aria-label', 'Close');
    x.textContent = '×';
    card.appendChild(x);

    var eyebrow = document.createElement('div');
    eyebrow.className = 'dcl-wo-eyebrow';
    eyebrow.textContent = 'YOUR DEAL!';
    card.appendChild(eyebrow);

    var perks = document.createElement('div');
    perks.className = 'dcl-wo-perks';
    perks.appendChild(perk(tagIcon(), discountCopy));
    card.appendChild(perks);

    var go = document.createElement('button');
    go.className = 'dcl-wo-go';
    go.type = 'button';
    go.textContent = 'Show my price';
    card.appendChild(go);

    var later = document.createElement('button');
    later.className = 'dcl-wo-skip';
    later.type = 'button';
    later.textContent = 'Save it for later';
    card.appendChild(later);

    wrap.appendChild(card);

    /*
     * Four ways out so the card can never trap a shopper. All three of the
     * non-apply routes save the deal rather than discard it, because a shopper
     * who closes the card is not saying no, they are saying not now, and the
     * card will not fire again this session.
     */
    go.addEventListener('click', apply);
    later.addEventListener('click', function () { save(wrap); });
    x.addEventListener('click', function () { save(wrap); });
    wrap.addEventListener('click', function (e) {
      if (e.target === wrap) save(wrap);
    });
    document.addEventListener('keydown', function esc(e) {
      if (e.key !== 'Escape') return;
      document.removeEventListener('keydown', esc);
      if (wrap.parentNode) save(wrap);
    });

    return wrap;
  }

  function show(reason) {
    if (shown || seen()) return;
    shown = true;
    writeSession(CFG.seenKey, '1');
    var wrap = build();
    document.body.appendChild(wrap);
    requestAnimationFrame(function () { wrap.classList.add('is-open'); });
    if (window.dataLayer && window.dataLayer.push) {
      window.dataLayer.push({ event: 'dcl_wahoo_offer_shown', trigger: reason });
    }
  }

  function scrolledPast() {
    var doc = document.documentElement;
    var height = doc.scrollHeight - window.innerHeight;
    if (height <= 0) return false;
    return (window.scrollY || doc.scrollTop) / height >= CFG.scrollPct;
  }

  function maybeShow(reason) {
    if (!armed || !human) return;
    show(reason);
  }

  /* 2026-09-25: timing cut to 1.5s arm, 3s dwell, 25% scroll so the card
     lands before a shopper clicks away. If the dwell mark passes before the
     first real interaction, the card now shows on that interaction instead
     of waiting for a scroll that may never come. */
  function onHuman() {
    human = true;
    if (dwellDone) maybeShow('dwell-late');
  }

  function start() {
    /* 2026-10-03: the deal is already in their cart, so do not pitch it again. */
    if (codeApplied()) { clearLocal(CFG.savedKey); return; }

    /* A saved deal outranks the card. Show the tab and stop, so a returning
       shopper gets their deal back rather than the same pitch again. */
    if (saved()) {
      showTab();
      return;
    }

    if (seen()) return;

    ['pointermove', 'touchstart', 'keydown', 'wheel'].forEach(function (evt) {
      window.addEventListener(evt, onHuman, { once: true, passive: true });
    });

    setTimeout(function () {
      armed = true;
      if (scrolledPast()) maybeShow('scroll-armed');
    }, CFG.armDelayMs);

    setTimeout(function () { dwellDone = true; maybeShow('dwell'); }, CFG.dwellMs);

    window.addEventListener('scroll', function () {
      if (scrolledPast()) maybeShow('scroll');
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
